/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */
import { Inject, Injectable, InjectionToken } from '@angular/core';

export interface BasicEnvironment {
  production?: boolean;

  [key: string]: any;
}

export const ENVIRONMENT = new InjectionToken<string>('ENVIRONMENT');

@Injectable({ providedIn: 'root' })
export class EnvironmentService<T extends BasicEnvironment = any> {
  constructor(@Inject(ENVIRONMENT) private readonly environment: T = {} as T) {}

  public getEnvironment() {
    return this.environment;
  }

  public isProduction(): boolean {
    return !!this.environment.production;
  }

  public isDevelopment(): boolean {
    return !this.environment.production;
  }

  public getEnvironmentProperty(key: string): any {
    return this.environment[key];
  }
}
